import React, { useEffect, useState } from "react";
import styles from "./cam.module.css";
import axios from "axios";
import { url } from "../../../../../../../../../App";
import { useNavigate } from "react-router";
import PDFViewer from "../../../../../PDFViewer/PDFViewer";
// import { useBorrowerContext } from "../../../../../../store/borrower-details";
import excelIcon from "../../../../../../../../../assets/icons8-excel.svg";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useParams } from "react-router-dom";
import { useBorrowerContext } from "../../../../../../store/borrower-details";

const CAM = () => {
  const { loanid } = useParams();
  const loanID = loanid;
  const [open, setOpen] = React.useState(false);
  const Navigate = useNavigate();
  const [pdDocsArr, setpdDocsArr] = useState([]);
  const [pdfModal, setPdfModal] = useState({
    open: false,
    data: "",
  });
  const [noDocsFound, setNoDocsFound] = useState(false);
  const [file, setFile] = useState(null);
  const [visible, setvisible] = useState(false);
  const [DeleteCamVisible, setDeleteCamVisible] = useState(false);
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const { borrowerData } = useBorrowerContext();
  const fetchedLoanDetails = borrowerData.loan;
  const foundLoan = fetchedLoanDetails.find((item) => item.loan_id === loanID);
  const [isDisbursed, setIsDisbursed] = useState(false);

  useEffect(() => {
    if (loanID) {
      setIsDisbursed(foundLoan?.loan_status === "DISBURSED");
    }
    //eslint-disable-next-line
  }, [foundLoan]);

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email,
        })
        .then((res) => {
          // console.log(res);
          setDeleteCamVisible(res.data[0].permission.delete_cam_doc);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [token, email]);

  const handleFileChange = (event) => {
    // Update the state with the selected file
    // setFile(event.target.files[0]);
    const selectedFile = event.target.files[0];
    if (event.target.files[0] === undefined) {
      return;
    }
    if (selectedFile) {
      if (
        selectedFile.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setFile(selectedFile);
      } else {
        toast.error("Invalid File Format. Choose MS Excel");
        event.target.value = null;
      }
    }
  };

  const handleUpload = async () => {
    setOpen(true);
    try {
      // Check if a file is selected
      if (!file || !loanID) {
        alert("select Loan ID & file");
        setOpen(false);
      }

      if (file) {
        // Read the file content as base64
        const reader = new FileReader();
        reader.onloadend = async () => {
          const base64Data = reader.result.split(",")[1];

          // API call to upload the file
          const response = await axios.post(url + "/cam/upload", {
            base64: base64Data,
            loanId: loanID,
          });
          console.log(response.data);
          if (response.data.auth === true) {
            setOpen(false);
            toast.success(response.data.message);
            fetchPDdocs();
          }
        };
        reader.readAsDataURL(file);
        // fetchPDdocs();
      }
    } catch (error) {
      setOpen(false);
      console.error("Error uploading file:", error);
    }
  };

  const fetchPDdocs = async () => {
    try {
      const borrowerReq = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        borrower_uniqueno: localStorage.getItem("uniqueID"),
      };
      const { data: borrowerDetails } = await axios.post(
        url + "/borrower/borrowertoalldetails",
        borrowerReq
      );
      if (borrowerDetails.logout) {
        Navigate("/");
        return;
      }
      console.log(borrowerDetails.message.cam);
      if (!borrowerDetails.message.cam) return;
      const currentCAM = borrowerDetails.message.cam.find((doc) => {
        return doc.loan_id.toString() === loanID.toString();
      });
      if (!currentCAM) {
        setpdDocsArr([]);
        setNoDocsFound(true);
        return;
      }
      setNoDocsFound(false);
      setpdDocsArr(currentCAM.pd_doc);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchPDdocs();
    // eslint-disable-next-line
  }, [loanID]);

  const showCAMdoc = async (doc) => {
    const request = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      borrower_uniqueno: localStorage.getItem("uniqueID"),
      doc_name: doc.doc_name,
      loan_id: loanID,
      doc_type: "xlsx",
    };
    const response = await axios.post(url + "/cam/viewdoc", request, {
      responseType: "arraybuffer",
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `CAM_doc.xlsx`;
    link.click();
  };

  const closePdfModal = () => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: false,
      data: "",
    }));
  };

  const deleteDocHandler = async (doc) => {
    setOpen(true);
    console.log(doc);
    const text = `Are you sure you want to Delete this Document?`;
    if (!window.confirm(text)) {
      setOpen(false);
      return;
    }
    const deleteReq = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      borrower_uniqueno: localStorage.getItem("uniqueID"),
      loan_id: loanID,
      doc_arr: {
        location: doc.location,
        doc_type: doc.doc_type,
        doc_name: doc.doc_name,
      },
    };
    const deleteRes = await axios.post(url + "/cam/deletedoc", deleteReq);
    if (!deleteRes.data.auth) {
      setOpen(false);
      toast.error(deleteRes?.data.message);
      return;
    }
    setOpen(false);
    toast.success(deleteRes.data.message);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  return (
    <>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {pdfModal.open && (
        <PDFViewer url={pdfModal.data} closeModal={closePdfModal} />
      )}
      <div className={styles.mainDiv}>
        {!isDisbursed && (
          <>
            <div className={styles.loanSelect}>
              <div>
                <input type="file" onChange={handleFileChange} />
                <button className={styles.uploadfile} onClick={handleUpload}>
                  Upload
                </button>
              </div>
            </div>
            <hr className={styles.hr} />
          </>
        )}

        <h3 style={{ textAlign: "center" }}>CAM Documents</h3>

        <div className={styles.pdfGrid}>
          {pdDocsArr?.map((doc) => {
            return (
              <div>
                <img
                  src={excelIcon}
                  alt=""
                  className={styles.docsPDF}
                  key={doc.doc_name}
                  onClick={() => showCAMdoc(doc)}
                />
                <br></br>
                {(DeleteCamVisible || visible) && !isDisbursed && (
                  <button
                    className={styles.deleteIcon}
                    onClick={() => deleteDocHandler(doc)}
                    title="Delete Excel"
                  >
                    Delete
                  </button>
                )}
              </div>
            );
          })}
        </div>
        {noDocsFound && (
          <h3 style={{ textAlign: "center" }}>
            No Docs Found. Please select an appropriate Loan Number.
          </h3>
        )}
      </div>
    </>
  );
};

export default CAM;
